module.exports = __webpack_public_path__ + "static/img/zhanqu_zuiqiang.5f15a327.png";